<template>
  <kst-print-table :data="items">
    <b-table-column
      v-slot="{ column, row }"
      field="DispatchID"
      :label="StclItemCatalog.DispatchID.ColumnLabel"
    >
      <kst-value :field="column.field" :data="row" :catalog="StclItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-sku-large"
      field="SKU"
      :label="StclItemCatalog.SKU.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="StclItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-qty-print"
      field="Qty"
      :label="StclItemCatalog.Qty.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="StclItemCatalog">
        <kst-value field="Packaging" :data="row" :catalog="StclItemCatalog"/>
      </kst-value>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-price"
      field="SellPrice"
      :label="StclItemCatalog.SellPrice.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="StclItemCatalog"/>
    </b-table-column>

    <template v-if="data.SpecialPriceCount > 0">
      <b-table-column
        v-slot="{ column, row }"
        cell-class="ks-col-specialpricename"
        field="SpecialPriceID"
      >
        <template v-if="row.SpecialPriceID !== null">
          <kst-value :field="column.field" :data="row" :catalog="StclItemCatalog"/>
        </template>
      </b-table-column>
    </template>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-subtotal"
      field="Total"
      :label="StclItemCatalog.Total.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="StclItemCatalog"/>
    </b-table-column>
  </kst-print-table>
</template>

<script>
import StclItemCatalog from "../StclItemCatalog.js";

export default {
  props: {
    data: Object,
    items: Array
  },
  data: () => ({
    StclItemCatalog: StclItemCatalog
  })
}
</script>